import React, { useState } from 'react';
import { Button } from '@mui/material';
import { runStatusCleanup } from './utils/cleanupStatuses';
import { useWorkspaceContext } from './context/WorkspaceContext';

export const StatusCleanupButton: React.FC = () => {
  const [isRunning, setIsRunning] = useState<boolean>(false);
  const { workspaceId } = useWorkspaceContext();

  const handleCleanup = async (): Promise<void> => {
    if (!workspaceId || isRunning) return;
    
    setIsRunning(true);
    try {
      await runStatusCleanup(workspaceId);
      window.location.reload(); // Refresh to show changes
    } catch (error) {
      console.error('Status cleanup failed:', error);
      alert('Failed to clean up duplicate statuses. Please try again.');
    } finally {
      setIsRunning(false);
    }
  };

  return (
    <Button
      variant="outlined"
      color="warning"
      onClick={handleCleanup}
      disabled={isRunning}
      sx={{
        minWidth: 200,
        '&.Mui-disabled': {
          cursor: 'not-allowed'
        }
      }}
    >
      {isRunning ? 'Cleaning...' : 'Clean Up Duplicate Statuses'}
    </Button>
  );
};